import * as React from 'react';
import cn from 'classnames';
import { Modal, ModalCloseReason, ModalDrawerControllerProps, ModalRenderProps, ModalSize } from '@economic/gaudi';
import LoadingBox from '../../../../home/PlanUpgradeDialog/LoadingBox';
import { SalesErrorDialog } from './SalesErrorDialog';
import { InvoicingMessage } from '../../../../../../types/internal-api';
import { Form } from '../../../../../shared/components/Form';
import { FormRenderProps } from 'react-final-form';
import { FormApi, AnyObject } from 'final-form';
import { ObjectSchema } from 'yup';
import { Calculation } from 'final-form-calculate';
import { t } from '../../../../../shared/components/l10n/l10n';
import SpinnerWithText from '../../../../../shared/components/ui/SpinnerWithText/SpinnerWithText';

export interface SalesModalFormProps {
    loading: boolean;
    loadingSpinnerWithText?: boolean;
    errorTitle: string;
    errorMessages: InvoicingMessage[];
    ariaLabel?: string;
    disclosure: React.ReactElement<React.HTMLAttributes<HTMLElement>>;
    onHide: (reason: ModalCloseReason) => void;
    className: string;
    drawer?: (formValues: AnyObject) => JSX.Element;
    extra?: Omit<React.ReactNode, 'Function'> | ((props: ModalRenderProps) => JSX.Element);
    children: (form: FormApi, drawer: ModalDrawerControllerProps) => React.ReactNode;
    initialData: any;
    onSubmit: (values: any) => Promise<any> | void;
    validationSchema?: ((values: object) => ObjectSchema<{}>) | ObjectSchema<{}>;
    size?: ModalSize;
    updates?: ((context?: any) => Calculation[]) | Calculation[];
}

export function SalesModalForm({
    loading,
    loadingSpinnerWithText,
    errorTitle,
    errorMessages,
    ariaLabel,
    disclosure,
    className,
    onHide,
    drawer,
    extra,
    children,
    initialData,
    onSubmit,
    validationSchema,
    size,
    updates,
}: SalesModalFormProps) {
    if (loading) {
        return (
            <Modal aria-label={t`TOAST_LOADING`} disclosure={disclosure} className={className} onHide={onHide} size={size}>
                <Modal.Content>{loadingSpinnerWithText ? <SpinnerWithText /> : <LoadingBox />}</Modal.Content>
            </Modal>
        );
    }

    if (errorMessages && errorMessages.length > 0) {
        return <SalesErrorDialog disclosure={disclosure} title={errorTitle} errors={errorMessages} onHide={onHide} />;
    }

    return (
        <Form
            initialData={{ ...initialData }}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            updates={updates}
            skipNotifications>
            {({ form, values }: FormRenderProps) => (
                <Modal
                    aria-label={ariaLabel}
                    disclosure={disclosure}
                    onHide={onHide}
                    className={cn('form', className)}
                    drawer={drawer && drawer(values)}
                    extra={extra}>
                    {({ drawer }) => children(form, drawer)}
                </Modal>
            )}
        </Form>
    );
}
